/** Pushes an event to the GTM data layer, which forwards it to GA4. */
export default function trackEvent(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}
